module.exports = __webpack_public_path__ + "img/ticketswap.2e4ffba9.svg";